
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ConceptPage = lazy(() => import('../pages/concept/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const IndividualPage = lazy(() => import('../pages/individual/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const NewsDetailPage = lazy(() => import('../pages/news-detail/page'));
const RecruitPage = lazy(() => import('../pages/recruit/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/concept',
    element: <ConceptPage />,
  },
  {
    path: '/business',
    element: <BusinessPage />,
  },
  {
    path: '/individual',
    element: <IndividualPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/news/:id',
    element: <NewsDetailPage />,
  },
  {
    path: '/recruit',
    element: <RecruitPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
